module.exports = __webpack_public_path__ + "static/img/img-4.825d4e1c.jpg";